<template>
  <div id="sensorMonitoring" class="animated fadeIn h-100">
    <b-row class="title">
      <b-col class="col-2 logo">
        <!-- <b-img src="static/img/logo_tp2.png" height="28"></b-img>
        <div class="text">[주]스마트제어계측</div> -->
      </b-col>
      <b-col class="col-8 cont">{{ title }}</b-col>
      <b-col class="col-2 watch">
        <div class="datetime">
          <div class="date">{{ datetime.year }}년</div>
          <div class="date">{{ datetime.month }}월</div>
          <div class="date">{{ datetime.date }}일</div>
          <div class="time pl5">{{ datetime.hour }}</div>
          <div class="timesep">:</div>
          <div class="time">{{ datetime.minute }}</div>
          <div class="timesep">:</div>
          <div class="time">{{ datetime.second }}</div>
        </div>
        <label class="autoRefresh mb0 mr10"
          ><i class="fa fa-repeat ftsz16"></i
        ></label>
        <b-form-select
          v-model="autoRefresh.value"
          :options="autoRefresh.options"
          @change="setMonitoringRefresh"
        ></b-form-select>
      </b-col>
    </b-row>
    <b-card class="border0" body-class="p10" :style="sensorStyle">
      <b-row v-for="item in sensorlist" :key="item.key">
        <b-col>
          <b-card class="border0 h-100" body-class="h-100 p-0">
            <b-row>
              <b-col class="col-4 image">
                <div class="header">{{ item.name }}</div>
                <b-img
                  :src="getStructureImage(item.key)"
                  @error="item.picErrorYn = true"
                  v-show="!item.picErrorYn"
                ></b-img>
              </b-col>
              <b-col class="col-8 sensorlist">
                <div
                  v-for="data in item.data"
                  :key="data.idx"
                  class="sensorInfo"
                >
                  <div
                    class="sensor"
                    :class="data.state === 'O' ? 'normal' : 'alarm'"
                  >
                    <div class="header">
                      <i class="fas fa-map-marker-alt mr10"></i
                      >{{ data.sensoralias }}
                      <!-- <b-img class="h19 mr10" src="static/img/marker1.png"></b-img>{{ data.sensoralias }} -->
                    </div>
                    <div class="content">
                      <div class="type">{{ data.sensortype }}</div>
                      <div class="value">
                        {{ data.state === "O" ? data.sensorval : "-" }}
                        {{ data.unit }}
                      </div>
                    </div>
                    <div class="footer">
                      <div class="stemp">
                        <i class="fas fa-thermometer-half mr10"></i>온도 :
                        {{ data.state === "O" ? data.temp : "-" }} °C
                      </div>
                      <div class="shumi">
                        <i class="fas fa-tint mr10"></i>습도 :
                        {{ data.state === "O" ? data.humid : "-" }} %
                      </div>
                    </div>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import utils from "../common/utils";

export default {
  data() {
    return {
      stid: null,
      title: null,
      sensorlist: [],
      sensorStyle: {
        height: "880px",
      },
      autoRefresh: {
        value: 60000,
        options: [
          { value: null, text: "없음" },
          { value: 60000, text: "1m" },
          { value: 120000, text: "2m" },
          { value: 180000, text: "3m" },
          { value: 240000, text: "4m" },
          { value: 300000, text: "5m" },
        ],
        timer: null,
      },
      datetime: {
        timer: null,
        year: null,
        month: null,
        date: null,
        day: null,
        hour: null,
        minute: null,
        second: null,
      },
    };
  },
  computed: {
    ...mapGetters(["getUserInfo"]),
  },
  created() {
    window.addEventListener("resize", this.resizeEvent);
    // Get Parameter
    this.title = String(this.$route.query.title);
    this.stid = String(this.$route.query.stid).split(",");
    // Remove getParameter
    history.replaceState({}, null, location.pathname + "#" + this.$route.path);
    // Setting DateTime
    this.setDatetime();
    this.datetime.timer = setInterval(() => {
      this.setDatetime();
    }, 1000);
  },
  beforeMount() {},
  mounted() {
    this.sensorStyle.height = window.innerHeight - 80 + "px";
    this.getData(true);
    this.startMonitoringRefresh(this.autoRefresh.value);
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeEvent);
    clearInterval(this.datetime.timer);
  },
  methods: {
    resizeEvent() {
      this.sensorStyle.height = window.innerHeight - 80 + "px";
    },
    setDatetime() {
      let now = moment();
      this.datetime.year = now.year();
      this.datetime.month = utils.lpad(String(now.month() + 1), 2, "0");
      this.datetime.date = utils.lpad(String(now.date()), 2, "0");
      this.datetime.day = now.day();
      this.datetime.hour = utils.lpad(String(now.hour()), 2, "0");
      this.datetime.minute = utils.lpad(String(now.minute()), 2, "0");
      this.datetime.second = utils.lpad(String(now.second()), 2, "0");
    },
    getData(firstYn) {
      var reqBody = {
        stid: this.stid,
      };
      this.$http
        .post("/sensor/getSensorListPerStid", reqBody)
        .then((res) => {
          if (res.data.resultyn === "Y") {
            var sensorlist = res.data.data;
            // 센서 리스트 초기화
            for (let i = 0; i < this.stid.length; i++) {
              let tmpList = [];
              for (let j = 0; j < sensorlist.length; j++) {
                if (this.stid[i] === sensorlist[j].stid) {
                  tmpList.push(sensorlist[j]);
                }
              }
              if (firstYn) {
                this.sensorlist.push({
                  key: this.stid[i],
                  name: tmpList[0].stname,
                  picErrorYn: false,
                  data: tmpList,
                });
              } else {
                this.sensorlist.splice(i, 1, {
                  key: this.stid[i],
                  name: tmpList[0].stname,
                  picErrorYn: false,
                  data: tmpList,
                });
              }
            }
          } else {
            this.setAlertTitle();
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getStructureImage(stid) {
      return (
        "/its/system/mainStructurePic/" +
        stid +
        "/" +
        moment().format("YYYY-MM-DD")
      );
    },
    setMonitoringRefresh(param) {
      if (param === null) {
        this.stopMonitoringRefresh();
      } else {
        this.startMonitoringRefresh(param);
      }
    },
    startMonitoringRefresh(time) {
      if (this.autoRefresh.timer === null) {
        this.autoRefresh.timer = setInterval(() => {
          this.getData(false);
        }, time);
      } else {
        this.stopMonitoringRefresh();
        this.startMonitoringRefresh(time);
      }
    },
    stopMonitoringRefresh() {
      if (this.autoRefresh.timer !== null) {
        clearInterval(this.autoRefresh.timer);
        this.autoRefresh.timer = null;
      }
    },
  },
};
</script>

<style lang="scss">
#sensorMonitoring {
  padding: 0;
  & div.title {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 80px;
    font-family: "나눔 고딕";
    color: #e2e2e2;
    background-color: #283046;
    border-bottom: 1px solid #373b40;
    & > .col {
      display: flex;
      align-items: center;
      justify-content: center;
      &.logo {
        & .text {
          margin-left: 15px;
          font-size: 18px;
          font-weight: 600;
          padding-bottom: 4px;
        }
      }
      &.cont {
        font-size: 28px;
        font-weight: 600;
      }
      &.watch {
        padding-right: 15px;
        justify-content: flex-end;
        & .datetime {
          position: absolute;
          right: 105px;
          top: 1px;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 350px;
          font-size: 22px;
          font-weight: 600;
          & > .date {
            padding: 0 5px;
          }
          & > .timesep {
            padding: 0 5px;
          }
        }
        & select {
          width: 70px;
          height: 40px;
          border-radius: 5px;
          border: 1px solid #666 !important;
          font-size: 16px;
        }
      }
    }
  }
  & > .card {
    & > .card-body {
      overflow-y: auto;
      height: 100%;
      background-color: #161d31;
      & > .row {
        min-height: 50%;
        padding: 10px;
        & > .col {
          & .card {
            & .card-header {
              padding: 10px 15px;
              & h6 {
                justify-content: center;
                font-size: 17px;
                line-height: unset;
              }
            }
            & .card-body {
              display: flex;
              align-items: center;
              & > .row {
                width: 100%;
                height: 100%;
                & > .col-4.image {
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  justify-content: flex-start;
                  & > .header {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 100%;
                    height: 45px;
                    background-color: #283046;
                    color: #e2e2e2;
                    font-size: 17px;
                    font-weight: 600;
                  }
                  & img {
                    // height: calc(100% - 20px);
                    width: calc(100% - 0px);
                    border-radius: 5px;
                  }
                }
                & > .col-8.sensorlist {
                  display: flex;
                  align-items: flex-start;
                  flex-wrap: wrap;
                  padding: 10px;
                  & > .sensorInfo {
                    flex: 0 0 25%;
                    max-width: 25%;
                    padding: 10px;
                    height: 200px;
                    & > .sensor {
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      flex-direction: column;
                      border-radius: 10px;
                      height: 100%;
                      width: 100%;
                      padding: 0px;
                      font-size: 15px;
                      color: #e2e2e2;
                      background: rgb(22, 29, 48);
                      &.normal {
                        border: 2px solid #404656;
                      }
                      &.alarm {
                        border: 2px solid rgb(214, 39, 40);
                      }
                      & > .header {
                        width: 100%;
                        height: 25%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        background-color: rgb(0, 14, 51);
                        border-radius: 10px 10px 0 0;
                        border-bottom: 2px solid #404656;
                        font-size: 16px;
                      }
                      & > .content {
                        width: 100%;
                        height: 50%;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: space-evenly;
                        & .type {
                          font-size: 16px;
                        }
                        & .value {
                          font-size: 20px;
                        }
                      }
                      & > .footer {
                        width: 100%;
                        height: 25%;
                        display: flex;
                        align-items: center;
                        justify-content: space-evenly;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/monitoring/Monitoring.vue